// extracted by mini-css-extract-plugin
module.exports = {"teamPhotosPlaceholder":"TeamPhotos_teamPhotosPlaceholder__0cNvk","teamPhotosWrapper":"TeamPhotos_teamPhotosWrapper__n7lK7","photo":"TeamPhotos_photo__NBKuc"};